import request from '../utils/request'
import type { ApiResult } from '../utils/request'

export function workerLoginApi(data: { employeeNo: string; password: string }) {
  return request.post<any, ApiResult<{ token: string; worker: any }>>('/worker-auth/login', {
    employee_no: data.employeeNo,
    password: data.password,
  })
}

export function getCurrentWorker() {
  return request.get<any, ApiResult<any>>('/worker-auth/info')
}

export function workerLogoutApi() {
  return request.post<any, ApiResult<void>>('/worker-auth/logout')
}
